import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './InventoryCounts.frontend.types'

@Injectable({ providedIn: 'root' })
export class InventoryCounts_cancel_count_task_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { countTaskIds: number[] }): Promise<{ errors?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.countTaskIds)) {
      missingRequiredInParams.push('\'countTaskIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/functions/cancel_count_task_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

